import { createSelector } from 'reselect'
import _ from 'lodash'

const getRoles = state => state.employee.role.roles

const getUserPermissions = state => state.employee.role.assignablePermissions

export const getManagerAvailablePermission = createSelector(
  getRoles, (roles) => {
    let role = _.find(roles, {'level': 2})
    if (role) {
      return _.groupBy(role.permissions, 'id')
    } else {
      return {}
    }
  }
)

export const getUserPermissionsOf = createSelector(
  getUserPermissions, (permissions) => {
    let permissionsOf = _.groupBy(permissions, 'access')
    return {
      app: permissionsOf['App'],
      backOffice: permissionsOf['Back-office']
    }
  }
)

export const getSubMenuOf = createSelector(
  getUserPermissions, (permissions) => {
    return _.groupBy(permissions, (permission) => permission.menu.toLowerCase())
  }
)



// WEBPACK FOOTER //
// ./app/selectors/employees/role.js